import { User, Book, Film, Link } from "react-feather";
import {
  animeQuery,
  mangaQuery,
  mediaQuery,
  charactersQuery,
} from "../graphql/queries";

const categories = [
  {
    value: "MEDIA",
    label: "🔗 Anime & Manga",
    emoji: "🔗",
    icon: <Link />,
    query: mediaQuery,
  },
  {
    value: "ANIME",
    label: "🎞️ Anime Only",
    emoji: "🎞️",
    icon: <Film />,
    query: animeQuery,
  },
  {
    value: "MANGA",
    label: "📕 Manga Only",
    emoji: "📕",
    icon: <Book />,
    query: mangaQuery,
  },
  {
    value: "CHARACTER",
    label: "👤 Characters",
    emoji: "👤",
    icon: <User />,
    query: charactersQuery,
  },
];

export default categories;
